export default __webpack_public_path__ + "static/favicon-26b053e7f453a0133d8cd48eb78df922.ico";